import React, { useEffect, useState } from "react";
import FilterSidebar from "../../../component/filter-sidebar/FilterSidebar";
import LazyLoadTable from "../../../component/table/lazy-load-table/LazyLoadTable";
import WfStatusSummary from "../../../workflows/components/WfStatusSummary";
import { searchPhieuXuatKho } from "../../services/servicesXuatKho";
import { DSXKBaoHiemColumns } from "../../constants/ColumnsXuatKho";
import AutocompleteObjectV2 from '../../../component/AutocompleteObjectV2';
import { Col } from "react-bootstrap";
import "../../PhanHeXuatKho.scss"
import {formatDateFromDTOCustom, formatDateToDTOCustom} from "../../../utils/FormatUtils";
import {getListKhoaPhong} from "../../../utils/ServicesUtils";

interface Props {
  searchData: any;
  setSearchData: React.Dispatch<any>;
  summaryStatus: any;
  handleRefreshData: (row: any, isUpdateSummaryStatus?: boolean, isUpdateDsBenhNhan?: boolean) => void;
  selectedRow?: any;
}

const TableDanhSachPhieuXuatKhoBaoHiem = (props: Props) => {
  const { searchData, setSearchData, handleRefreshData, summaryStatus, selectedRow } = props;
  const [listStatus, SetListStatus] = useState([])
  const handleSearch = (data: any) => {
    const convertData = {
      fromDate: formatDateFromDTOCustom(data.period?.fromDate) || null,
      toDate: formatDateToDTOCustom(data.period?.toDate) || null,
      keyword: data.keyword?.trim() || null,
    };
    setSearchData({
      ...searchData,
      ...convertData
    });
  };

  useEffect(() => {
    let list = summaryStatus?.length && summaryStatus?.map((item: any) => {
      return {
        ...item,
        code: item?.statusCode,
        name: item?.statusName
      }
    })
    SetListStatus(list)
  }, [summaryStatus]);

  const handleSelectedRow = (row: any, index: number | null) => {
    handleRefreshData(row, false);
  };

  return (
    <div className="bangDSBenhNhan position-relative spaces gap-8">
      <div className="border-left-0 h-calc-300px">
        <div className="flex spaces bg-white  align-items-center mb-3 pl-7 pr-12">
          <Col lg={6}  >
            {/* <div className="flex spaces"> */}
            <AutocompleteObjectV2
              options={[]}
              placeholder="Phòng ban"
              isSearchDefauilt={true}
              name={"department"}
              searchFunction={getListKhoaPhong}
              searchObject={{}}
              onChange={(options: any) =>
                setSearchData({
                  ...searchData,
                  departmentId: options?.id
                })}
              // value={warehouseExportType || ""}
              className="autocomplete-custom-renderform mt-6 pl-5 radius spaces  h-29"
            />
            {/* </div> */}
          </Col>
          <Col lg={6}  >
            <div className="flex">
              <AutocompleteObjectV2
                options={listStatus || []}
                isSearchDefauilt={true}
                placeholder="Trạng thái"
                name={"status"}
                onChange={(options: any) =>
                  setSearchData({
                    ...searchData,
                    slipStatus: options?.statusCode
                  })}
                // value={warehouseExportType || ""}
                className="autocomplete-custom-renderform mt-6 pl-5 radius spaces  h-29"
              />
            </div>
          </Col>
        </div>
        <FilterSidebar
          onSearch={handleSearch}
        />
        <LazyLoadTable
          searchData={searchData}
          columns={DSXKBaoHiemColumns}
          axiosReq={searchPhieuXuatKho}
          className="spaces table-ds-phieu-xuat-bh"
          onRowClick={handleSelectedRow}
          idSelected={selectedRow?.id}
          refreshOnRowClick={false}
        />
      </div>
      <div className="d-flex flex-column spaces w-100 pb-3 gap-5 position-absolute bottom-15">
        <WfStatusSummary summaryStatus={summaryStatus || []} />
      </div>
    </div>
  );
};

export { TableDanhSachPhieuXuatKhoBaoHiem };

